// Insphirea Scent Finder: 3 weighted scent questions (notes 2x) -> Harmonea/Reposea/Invigorea, + format.
(function () {
  const root = document.querySelector("[data-ins-finder]");
  if (!root) return;
  const steps = [...root.querySelectorAll(".ins-step")];
  const qCount = steps.filter((s) => !s.classList.contains("ins-finder-result")).length;
  const resultStep = root.querySelector(".ins-finder-result");
  const bar = root.querySelector(".ins-bar i");
  const label = root.querySelector(".ins-finder-label");
  const back = root.querySelector(".ins-finder-back");
  const answers = [];
  let i = 0;

  const CDN = "https://cdn.shopify.com/s/files/1/0790/1442/9000/files/";
  const SIG = {
    H: { name: "Harmonea", tag: "Fris en harmonieus", desc: "Bergamot, citrus en rood fruit. Licht en opwekkend.", life: CDN + "DSC04904-Verbeterd-NR-bewerkt-7.jpg?v=1719249327", coll: "/collections/harmonea",
      fmt: { kaars: { name: "Harmonea Geurkaars", price: "€32,00", handle: "harmonea-geurkaars" }, stokjes: { name: "Harmonea Geurstokjes", price: "€28,00", handle: "harmonea-geurstokjes" }, spray: { name: "Harmonea Roomspray", price: "€30,00", handle: "harmonea-roomspray" } } },
    R: { name: "Reposea", tag: "Warm en rustgevend", desc: "Zacht en omhullend. Warmte, rust en luxe.", life: CDN + "reposea-geurkaars.webp?v=1719249338", coll: "/collections/reposea",
      fmt: { kaars: { name: "Reposea Geurkaars", price: "€32,00", handle: "geurkaars-reposea" }, stokjes: { name: "Reposea Geurstokjes", price: "€28,00", handle: "geurstokjes-reposea" }, spray: { name: "Reposea Roomspray", price: "€30,00", handle: "roomspray-reposea" } } },
    I: { name: "Invigorea", tag: "Vurig en houtachtig", desc: "Sandelhout, ceder en amber. Krachtig en verwarmend.", life: CDN + "invigorea_nature_shot.png?v=1758044115", coll: "/collections/invigorea",
      fmt: { stokjes: { name: "Invigorea Geurstokjes", price: "€44,00", handle: "invigorea-geurstokjes" } } },
  };

  const T = (window.INS_I18N && window.INS_I18N.finder) || {};
  const ROOT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || "/").replace(/\/$/, "");

  function show(n) {
    steps.forEach((s) => s.classList.remove("is-active"));
    steps[n].classList.add("is-active");
    if (n < qCount) { label.textContent = (T.question || "Vraag") + " " + (n + 1) + " " + (T.of || "van") + " " + qCount; bar.style.width = ((n + 1) / qCount) * 100 + "%"; }
    else { label.textContent = T.result_label || "Jouw resultaat"; bar.style.width = "100%"; }
    back.hidden = n === 0 || n >= qCount;
  }
  function winner() {
    const s = { H: 0, R: 0, I: 0 };
    answers.forEach((a) => { if (a.sig) s[a.sig] += a.w; });
    const max = Math.max(s.H, s.R, s.I);
    const notes = answers[1] && answers[1].sig;
    if (notes && s[notes] === max) return notes;
    return ["H", "R", "I"].find((k) => s[k] === max);
  }
  function renderResult() {
    const key = winner();
    const s = SIG[key];
    const fk = (answers[3] && answers[3].fmt) || "stokjes";
    const f = s.fmt[fk] || Object.values(s.fmt)[0];
    const price = (window.INS_FINDER_PRICES && window.INS_FINDER_PRICES[f.handle]) || f.price;
    const tag = (T.sig && T.sig[key] && T.sig[key].tag) || s.tag;
    const desc = (T.sig && T.sig[key] && T.sig[key].desc) || s.desc;
    const fmtLabel = (T.fmt && T.fmt[fk]) || "";
    const prodName = fmtLabel ? s.name + " " + fmtLabel : (f.name || s.name);
    const chips = answers.map((a) => '<span class="ins-chip">' + (((T.traits && T.traits[a.trait]) || a.trait)) + "</span>").join("");
    resultStep.innerHTML =
      '<div class="ins-result"><figure class="ins-result__media ins-media"><img src="' + s.life + '" alt="' + s.name + '"></figure>' +
      '<div class="ins-result__info"><span class="ins-eyebrow">' + (T.your_signature || "Jouw signatuur") + '</span><h3 class="ins-result__name">' + s.name + "</h3>" +
      '<p class="ins-result__tag">' + tag + "</p><div class=\"ins-chips\">" + chips + "</div>" +
      '<p class="ins-result__desc">' + desc + "</p>" +
      '<p class="ins-result__begin">' + (T.start_here || "Begin hier:") + ' <b>' + prodName + "</b> · " + price + "</p>" +
      '<div class="ins-cta"><a class="ins-btn ins-btn--primary" href="' + ROOT + '/products/' + f.handle + '">' + (T.view_product || "Bekijk dit product") + '</a><a class="ins-link" href="' + ROOT + s.coll + '">' + (T.view_line || "Bekijk de lijn") + '</a></div>' +
      '<button class="ins-restart" type="button">' + (T.restart || "Opnieuw beginnen") + '</button></div></div>';
    resultStep.querySelector(".ins-restart").addEventListener("click", restart);
  }
  function restart() { answers.length = 0; i = 0; show(0); }

  root.querySelectorAll(".ins-opt").forEach((opt) => opt.addEventListener("click", () => {
    answers[i] = opt.dataset.sig ? { sig: opt.dataset.sig, w: +opt.dataset.weight, trait: opt.dataset.trait } : { fmt: opt.dataset.fmt, trait: opt.dataset.trait };
    i++;
    if (i >= qCount) { renderResult(); show(steps.length - 1); } else show(i);
  }));
  back.addEventListener("click", () => { if (i > 0) { i--; show(i); } });
  show(0);
})();
